/**
 * Item system constants for Idle Depths.
 */

/**
 * Maximum number of unique items that can be stored in bank.
 * This is a soft limit for performance optimization.
 */
export const MAX_BANK_ITEMS = 1000;

/**
 * Fallback icon name when item icon is not found.
 * Uses Lucide icon names.
 */
export const ITEM_ICON_FALLBACK = 'Package';

/**
 * Default sell price multiplier for shops.
 * Items sell for 60% of their base value.
 */
export const SELL_PRICE_MULTIPLIER = 0.6;

/**
 * Starting currency for new characters.
 */
export const STARTING_CURRENCY = 100;

/**
 * Starting items for new characters.
 *
 * Each entry is [itemId, quantity].
 * These items are added to the bank when a character is first selected.
 */
export const STARTING_ITEMS: ReadonlyArray<readonly [string, number]> = [
  ['iron_sword', 1],
  ['wooden_shield', 1],
  ['bread', 5],
] as const;

/**
 * Transaction threshold that triggers confirmation dialog.
 * Purchases over this amount will prompt for confirmation.
 */
export const TRANSACTION_CONFIRM_THRESHOLD = 100;

/**
 * Search input debounce delay in milliseconds.
 */
export const SEARCH_DEBOUNCE_MS = 300;
